"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OCP = (typeof Liferay !== 'undefined'
    ? require('./contexts/liferay')
    : require('./contexts/common')).default;
exports.default = OCP;
//# sourceMappingURL=index.js.map